const getters = {
    classStatus: state => state.classStatus,
    classErrors: state => state.classErrors,
    classes: state => state.classes,
    classesCount: state => state.classesCount,
    classDetailById: state => id => {
        return state.classes.find(hpcclass => hpcclass.class_id === id);
    },
};

export default getters;
